import React from "react";

import { TTip } from "@data-types/offer/event-row/EventRow";
import EventHistoryStatusIcon from "@features/offer/shared/event/offer-history/EventHistoryStatusIcon";
import classNames from "classnames";
import { getOfferHistoryStatusClass } from "@features/offer/shared/event/offer-history/utils";

export function OfferHistoryPlayerTipButton(props: {
	tip: TTip["tip"];
	isStats?: boolean;
}) {
	const status = props.tip?.status || 0;

	const wrapperClasses = classNames({
		"offer--player__item quote quote--special": !props.isStats,
		"card--players__heading": props.isStats,
	});

	const marginClasses = classNames({
		"offer--player__margin quote--special__tip quote quote--margin":
			!props.isStats,
		"card--players__title": props.isStats,
	});

	const tipClasses = classNames(
		{
			"quote--special__odd quote quote--button": !props.isStats,
			"card--players__quota quota": props.isStats,
		},
		getOfferHistoryStatusClass(status)
	);

	return (
		<div className={wrapperClasses}>
			<div className={marginClasses} title={props.tip?.displayTip}>
				{props.tip?.displayTip}
			</div>
			<div className={tipClasses}>
				<EventHistoryStatusIcon
					status={status}
				/>
			</div>
		</div>
	);
}
